import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';

import { UsersInRoleComponent } from 'src/app/parameters/users/role-edition/users-in-role/users-in-role.component';
import { RolesForUserComponent } from 'src/app/parameters/users/users/user-edition/roles-for-user/roles-for-user.component';

downgradedAngularModule
  .directive('angularRolesForUser', downgradeComponent({ component: RolesForUserComponent }))
  .directive('angularUsersInRole', downgradeComponent({ component: UsersInRoleComponent }))
  ;
